<template>
    <playerList :type="'injury'"></playerList>
</template>

<script>
    import playerList from "../components/newPlayerList";
    export default {
        name: "injuryReport",
        components:{
            playerList
        }
    }
</script>

